<footer class="footer">
  <div class="footer__inner">
    <div class="footer__mobile-logo">
      <img
        class="footer__logo"
        [src]="logoSrc"
        alt="GlobalConnect"
        width="256"
        height="42"
      />
    </div>

    <div class="footer__container">
      <nav
        class="footer__link-groups"
        [attr.aria-label]="'footer.navigation' | translate"
      >
        <h2 class="visually-hidden">{{ 'footer.navigation' | translate }}</h2>

        @for (group of footer.linkGroups; track group.titleKey) {
        <div
          class="footer__link-group"
          [attr.aria-labelledby]="groupHeadingId(group.titleKey)"
        >
          <div
            class="footer__link-group-title"
            [id]="groupHeadingId(group.titleKey)"
          >
            <gc-text variant="paragraphHeading" level="3" textColor="invert">
              {{ group.titleKey | translate }}
            </gc-text>
          </div>

          <ul class="footer__links">
            @for (link of group.links; track link.labelKey) {
            <li>
              @if (link.kind === 'internal') {
              <app-footer-link [routerLink]="link.path">
                {{ link.labelKey | translate }}
              </app-footer-link>
              } @else {
              <app-footer-link
                [href]="link.href"
                [openInNewTab]="true"
                [isPdfDocument]="link.documentType === 'pdf'"
              >
                {{ link.labelKey | translate }}
              </app-footer-link>
              }
            </li>
            }
          </ul>
        </div>
        }
      </nav>

      <div class="footer__brand">
        <img
          class="footer__logo footer__logo--desktop"
          [src]="logoSrc"
          alt="GlobalConnect"
          width="256"
          height="42"
        />

        <div class="footer__addresses">
          @for (address of footer.addresses; track $index) {
          <address class="footer__address">
            @for (line of address; track $index) {
            <gc-text variant="body" textColor="invert">{{ line }}</gc-text>
            }
          </address>
          }
        </div>

        <ul class="footer__socials">
          @for (social of footer.socialLinks; track social.href) {
          <li>
            <a
              class="footer__social-link"
              [href]="social.href"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="'footer.social.' + social.icon | translate"
            >
              <img
                [src]="'assets/' + social.icon + '.svg'"
                alt=""
                aria-hidden="true"
              />
              <span class="visually-hidden">{{
                'footer.newTab' | translate
              }}</span>
            </a>
          </li>
          }
        </ul>

        <gc-text class="footer__copyright" textColor="invert">
          &copy; {{ currentYear }} {{ footer.companyName }}
        </gc-text>
      </div>
    </div>
  </div>
</footer>
